import { Component } from 'react';
import PropTypes from 'prop-types';
import { Tracking } from '@nerdwallet/nw-client-lib';
import omit from 'lodash/fp/omit';

import { formInputChangeEventFields } from '../../lib/editing-configs';

const trackingFields = ['formName', 'fieldName', 'fieldValue'];
export const omitTrackingData = omit(trackingFields);

class Expandable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: props.isExpanded,
    };
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  toggleExpanded() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const isExpanded = !this.state.isExpanded;

    this.setState({
      isExpanded,
    });

    // report to the possible hook
    this.props.afterToggle(isExpanded);

    const { trackingData } = this.props;
    const { formName, fieldName, fieldValue } = trackingData;

    const trackingDataIsValid = formName && fieldName && fieldValue;

    if (trackingDataIsValid) {
      if (isExpanded) {
        Tracking.formOpen(trackingData);
      } else {
        Tracking.formCancel(trackingData);
      }
    }
  }

  // Instead of rendering `children`, we use the render prop provided by the
  // component that is consuming the `Expandable`, This allows us the parent
  // component to render whatever it wants without merging its properties with
  // a HoC, and isolates the values pertinent to the expansion as the arguments
  // of the render function.
  // A detailed explanation of Render props can be found here:
  // https://goo.gl/GU8fG2
  render() {
    return this.props.render(this.toggleExpanded, this.state.isExpanded);
  }
}

export const trackingPropTypes = {
  formName: PropTypes.string,
  fieldName: PropTypes.string,
  fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Expandable.propTypes = {
  render: PropTypes.func.isRequired,
  afterToggle: PropTypes.func,
  isExpanded: PropTypes.bool,
  // tracking
  trackingData: PropTypes.shape(trackingPropTypes),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Expandable.defaultProps = {
  isExpanded: false,
  afterToggle: () => {},
  trackingData: {},
};

Expandable.getEditingConfig = () => formInputChangeEventFields;

export default Expandable;
